import { render, staticRenderFns } from "./RowArticleWiki.vue?vue&type=template&id=0c3bb6f4&scoped=true"
import script from "./RowArticleWiki.vue?vue&type=script&lang=js"
export * from "./RowArticleWiki.vue?vue&type=script&lang=js"
import style0 from "./RowArticleWiki.vue?vue&type=style&index=0&id=0c3bb6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3bb6f4",
  null
  
)

export default component.exports